import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { permissionGuard } from '../../../lib/guards/permission.guard';

const guards = [roleGuard('ADMIN_MASTER'), permissionGuard('HOME_SCREEN$READ')];

const listLoader = () =>
  import(
    '../homepage-builder-header-footer/components/smart/hf-list-page/hf-list-page.component'
  ).then((m) => m.HfListPageComponent);

const detailLoader = () =>
  import(
    './components/smart/homepage-builder-ml-detail-page/homepage-builder-ml-detail-page.component'
  ).then((m) => m.HomepageBuilderMlDetailPageComponent);

export const homepageBuilderMemberLoginRoutes: Routes = [
  {
    path: 'homepage-master/home/member-login',
    data: { title: 'Homepage Member & Login' },
    canActivate: guards,
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: listLoader,
        children: [
          {
            path: ':id',
            loadComponent: detailLoader,
            data: { title: 'Homepage Member & Login Detail' },
          },
        ],
      },
    ],
  },
];
